export default {

  headline: '丝吉利娅媒体服务中心',
  search_info: '请问您需要检索什么内容？',
  back: '返回',
  no_results: '很遗憾没有为您找到对应的结果，请检查您的检索信息。',
  service: {
    downloads: '文件',
    videos: '视频',
    faq: '智能家居常见问题解答'
  },

  service_search: {
    category_placeholder: "按类别过滤"
  },
  service_download: {
    select_info: '请选择您的搜索范围',
    select_productgroup: '请选择产品组',
    select_product: '请选择产品',
    select_type: '选择条目',
    option_language: "语",

    types: {
      tec_info: '技术信息',
      installation: '装配手册',
      planning: '规划文档',
      catalog: '产品目录与手册',
      order_forms: '订购表格',
      maintenance: '维护与保养手册',
      construction_drawings: '结构图纸',
      software: '软件',
      certificate: '证书与准则',
      press: '新闻及市场营销资料',
      videos: '视频',
      undefined: '其他',
      commercial: '商业短片',
      product_video: '产品视频',
      operating: '操作',
      'function': '功能',
      'assembly': '安装',
      'assembly_instructions': '安装说明',
      'installation_video': '装配',
      'brochure': '说明书',
      'tec_catalog': '技术目录',
      'tec_sheet': '技术参数表',
      'usage_charts': '应用图',
      'profile_sheet': '文件配置数据',
      'operations_manual': '操作及维护手册',
      hardware_info: '五金信息',
      'installation_suggestion' : '装配推荐',
      'general' : '常规',
      'troubleshooting' : '故障排除',
      "smarthome:general" : '综合',
      'smarthome:installation' : '安装',
      'smarthome:troubleshooting' : '故障排除',
      'smarthome:startup' : '运行',
      'smarthome:operating' : '操作',

    },
    filter_sorting: {
      filter: "过滤器",
      sorting: "排序",
      asc: "按字母顺序（A-Z）排列",
      desc: "按字母顺序（Z-A）排列",
      date_asc: "按日期从远到近",
      date_desc: "按日期从近到远",
      relevance: "关联性",
      facet_headline: "过滤搜索结果",
      facet_filter_lang: "语言",
      facet_filter_type_id: "类型",
      facet_filter_level_0: "类别",
      filter_remove: "重置过滤结果",
      show_hide: "显示过滤结果",

    },
    result: {
      count_media: "条目",
      show_results: "显示",
      preview_type_catalog: "HTML",
      lang_not_available: "您所选定的语言暂时不可用" ,
      version_info: "This link leads to the latest version of the documentation. If you need an older version, please contact your SIEGENIA customer service representative."
    }
  }

};

